import React from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Security from "../LaunchpadHome/SubFooter";
import { FaEnvelope } from "react-icons/fa";
import { CiGlobe } from "react-icons/ci";

export default function Privacypolicy() {
  return (
    <>
      <Header />
      <div className="bg-darkgrey">
        <section className="privacypolicy py-5 ">
          <Container>
            <Row>
              <Col lg={12}>
                <div>
                  <div className="position-relative text-white">
                    <div className="mb-4 pb-1">
                      <h1 className="text-white mb-3">Privacy Policy</h1>

                      <p className="text-light-grey">
                        <span className="text-white">Effective Date:</span> April 23, 2025
                      </p>

                      <p className="text-light-grey mb-3">
                        Welcome to the{" "}
                        <strong className="text-white">
                          INFI MultiChain CDEX Layer,
                        </strong>{" "}
                        a decentralised, community-governed
                        environment. Your privacy and self-sovereignty are important to us. This Privacy Policy outlines
                        how limited, non-sensitive user interaction data may be used solely to enhance platform access and
                        communications.
                      </p>
                      <p className="text-light-grey">
                        <strong className="text-white">⚠ Disclaimer :</strong> INFI MultiChain CDEX is a decentralised environment. By connecting your selfcustodied wallet and interacting with the platform, you acknowledge that no custodial control,
                        identity processing, or personal data management is performed by the platform itself. This Privacy
                        Policy is for transparency purposes only and does not imply or constitute compliance with any
                        specific jurisdictional regulatory framework.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">1. Platform Overview</h5>
                      <p className="text-light-grey">
                        INFI MultiChain CDEX Layer is a decentralised smart-contract-based platform that facilitates
                        crypto-asset interaction. It does not collect, process, or store user data through centralised
                        infrastructure. Platform logic is governed entirely through the autonomous ©SbSe Protocol.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">2. What We (May) Collect</h5>
                      <p className="text-light-grey">
                        The platform does <strong className="text-white">not require any registration.</strong> Users access the ecosystem by connecting a selfcustodied wallet.
                      </p>

                      <div>
                        <p className="text-light-grey">
                          In optional contexts (e.g., support or subscriptions), users may provide:
                        </p>
                        <ul className="text-light-grey lh-lg">
                          <li>Email address (only for communication)</li>
                          <li>Display name (if chosen)</li>
                          <li>Wallet address (auto-detected via wallet connection)</li>
                        </ul>
                      </div>
                      <p className="text-light-grey">
                        No personally identifiable information (PII), identity documentation, or sensitive data is requested
                        or stored.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">
                        3. How Limited Information Is Used
                      </h5>
                      <p className="text-light-grey">
                        If a user opts to provide an email address or display name (e.g., for updates or community
                        engagement), it may be used to:
                      </p>
                      <div>
                        <ul className="text-light-grey lh-lg">
                          <li>
                            Deliver platform-related updates or community news
                          </li>
                          <li>Respond to user-initiated support requests</li>
                          <li>
                            Offer opt-in communications (with the ability to unsubscribe anytime)
                          </li>
                        </ul>
                      </div>

                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">4. Data Security & Storage</h5>
                      <p className="text-light-grey">
                        We do <strong className="text-white">not</strong> store
                        private keys, personal data, or funds. All activity is conducted directly via
                        blockchain interactions and self-custodied wallets. Email and communication data, if voluntarily
                        provided, are stored through secure, encrypted channels and never shared with unauthorised third
                        parties.
                      </p>

                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">5. No KYC Requirement</h5>
                      <p className="text-light-grey my-3">
                        Consistent with the platform's decentralised model:
                      </p>
                      <div>
                        <ul className="text-light-grey lh-lg">
                          <li>No KYC, identity verification, or user profiling is conducted</li>
                          <li>Users maintain full control and privacy over their identity and digital assets </li>
                        </ul>
                      </div>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">6. Protocol-Based Governance</h5>
                      <p className="text-light-grey">
                        All interaction fees and platform logic are transparently managed on-chain through the ©SbSe
                        Protocol. There is no human-controlled override, manual intervention, or off-chain modification of
                        rules or structures.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">
                        7. Visibility of Platform Activity
                      </h5>
                      <p className="text-light-grey">
                        Any publicly visible protocol activity (such as smart contract-based distributions or network
                        participation logic) occurs transparently on supported blockchains and is fully auditable by users.
                        No real-world identities are associated with any data on-chain.
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">8. Data Sharing Policy</h5>
                      <p className="text-light-grey my-3">
                        We do <strong className="text-white">not:</strong>
                      </p>
                      <div>
                        <ul className="text-light-grey lh-lg">
                          <li>Sell user information</li>
                          <li>Rent or share data with external entities</li>
                          <li>Perform third-party marketing activities</li>
                        </ul>
                        <p className="text-light-grey">
                          All optional communication data is processed solely for user-requested updates or support.
                        </p>
                      </div>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">9. Your Communication Rights</h5>
                      <p className="text-light-grey my-3">
                        Users may, at any time:
                      </p>
                      <div>
                        <ul className="text-light-grey lh-lg">
                          <li>
                            Request a copy of any communication data they provided (e.g., email messages)
                          </li>
                          <li>Unsubscribe from platform emails</li>
                          <li>Request that email-based interactions be removed from communication systems</li>
                        </ul>
                      </div>
                      <p className="text-light-grey">
                        Contact: support@infimultichain.com
                      </p>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">
                        10. Jurisdictional Compliance Note
                      </h5>
                      <p className="text-light-grey my-3">
                        While the platform respects privacy best practices, it operates as a decentralised protocol outside of
                        traditional data processing models. Therefore:
                      </p>
                      <div>
                        <ul>
                          <li>
                            The system does not align with or fall under GDPR, CCPA, or similar jurisdictional
                            frameworks
                          </li>
                          <li>
                            No centralised data is retained, and no compliance filings or registrations are made with
                            regulatory bodies
                          </li>
                        </ul>
                        <p>Users participate at their own discretion and are encouraged to use self-custody best practices.</p>
                      </div>
                    </div>
                    <div className="mb-4 pb-1">
                      <h5 className="text-white">
                        11. Changes to This Policy
                      </h5>
                      <p className="text-light-grey">
                        This Privacy Policy may evolve to reflect technical or community-led protocol updates. Updates
                        will be communicated through official platform channels or (if opted in) via email.
                      </p>
                    </div>
                    <div className="">
                      <h5 className="text-white">
                        12. . Contact
                      </h5>
                      <p className="text-light-grey my-3">
                        For privacy-related questions or communication preferences:
                      </p>
                      <ul className="lh-lg text-light-grey list-unstyled">
                        <li><span><FaEnvelope /></span>&nbsp;&nbsp;<strong className="text-white">Email :</strong> support@infimultichain.com </li>
                        <li><span><CiGlobe /></span>&nbsp;&nbsp;<strong className="text-white">Website :</strong> <a href="https://www.infimultichain.com/">https://www.infimultichain.com/</a></li>
                        <li><span><CiGlobe /></span>&nbsp;&nbsp;<strong className="text-white">Launchpad :</strong> <a href="https://launchpad.infimultichain.com/">https://launchpad.infimultichain.com/</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}
